import React, { useState, useRef, useEffect } from 'react'
import { IconButton } from "@mui/material"
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import './styless.scss'
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

interface PolicyProps {
  collapsed?: boolean;
}

export default function Policy({ collapsed }: PolicyProps) {
  const [panelOpen, setPanelOpen] = useState(false)
  const rootRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(e.target as Node)) {
        setPanelOpen(false)
      }
    }
    if (panelOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [panelOpen])

  const publicUrl = process.env.PUBLIC_URL || '';
  const policyUrl = `${publicUrl}/policy.html`;
  const privacyUrl = `${publicUrl}/privacy.html`;

  return (
    <div className="policy-root" ref={rootRef} style={{left: '10px'}}>
      {panelOpen && (
        <div className="policy-panel">
          <div className="policy-link" onClick={() => window.open(policyUrl, '_blank')}>用户协议 <ArrowOutwardIcon sx={{ fontSize: 14 }} /></div>
          <div className="policy-link" onClick={() => window.open(privacyUrl, '_blank')}>隐私政策 <ArrowOutwardIcon sx={{ fontSize: 14 }} /></div>
          <div className="policy-divider" />
          <div className="policy-text">上海奈洛科技有限公司</div>
          <a className="policy-link-text" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">沪ICP备2025129375号</a>
        </div>
      )}
      <IconButton aria-label="policy" onClick={() => setPanelOpen((v) => !v)} sx={{ backgroundColor: 'var(--c-bg-secondary)', '&:hover': { backgroundColor: 'var(--c-border)' } }}>
        <FormatListBulletedIcon />
      </IconButton>
    </div>
  )
}